<template>
    <div id="silhouette">
        <Banner title="學術活動" :breadcrumbs="breadcrumbs" type="activity"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Event Photo gallery" chtFirst="活動" chtSecond="花絮" :center="true"></Title>
            </div>
            <section class="list_box">
                <div
                    class="list"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                >
                    <div class="item" v-for="(item,index) in List" :key="index">
                        <ImageCard
                            :Id="item.Id"
                            :Title="item.Title"
                            :Img="item.Cover"
                            :info="item.Introduction"
                            @click.native="openAlbum(item.Id)"
                        ></ImageCard>
                    </div>
                </div>
                <notfound v-if="List.length == 0" info="目前沒有最新花絮，"></notfound>
            </section>
        </div>
        <div
            class="popup animated fadeIn"
            :style="`backgroundImage:url(${bgImage})`"
            v-show="popupShow && Images.length > 0"
        >
            <div class="title">
                <span>{{DetailTitle}}</span>
                <div class="close" @click="closeAlbum">X</div>
            </div>
            <div class="slider">
                <!-- swiper1 -->
                <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                    <swiper-slide
                        v-for="(img,index) in Images"
                        :key="index"
                        :style="`backgroundImage:url(${img.Url?img.Url: ''})`"
                    ></swiper-slide>
                    <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                    <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                </swiper>
                <!-- swiper2 Thumbs -->
                <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                    <swiper-slide
                        v-for="(img,index) in Images"
                        :key="index"
                        :style="`backgroundImage:url(${img.Url?img.Url: ''})`"
                    ></swiper-slide>
                </swiper>
            </div>
        </div>
        <div
            class="popup animated fadeIn"
            :style="`backgroundImage:url(${bgImage})`"
            v-show="popupShow && YoutubeUrl"
        >
            <div class="title">
                <span>{{DetailTitle}}</span>
                <div class="close" @click="closeAlbum">X</div>
            </div>
            <div class="slider">
                <div class="video">
                    <iframe width="560" height="315" :src="`https://www.youtube.com/embed/${YoutubeUrl}?autoplay=1`" :title="`${DetailTitle}`" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
            </div>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import ImageCard from "@/components/activity/imageCard";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Common from "@/common";
import API from "@/service/activity.js";
export default {
    name: "silhouette",
    components: {
        ImageCard,
        swiper,
        swiperSlide
    },
    props: ["propsilhouette"],
    data() {
        return {
            screenWidth: document.documentElement.clientWidth,
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "學術活動"
                },
                {
                    url: "/Academic/Silhouette",
                    title: "活動花絮"
                }
            ],
            bgImage: require("@/assets/banners/activity.png"),
            popupShow: false,
            swiperOptionTop: {
                spaceBetween: 10,
                init: false,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            swiperOptionThumbs: {
                init: false,
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
                slideToClickedSlide: true
            },
            List: [],
            Images: [],
            YoutubeUrl: null,
            Init: true,
            DetailTitle: "",
            Totalpage: 1,
            Page: 1,
            Count: 10,
            busy: false,
            isLoading: false
        };
    },
    methods: {
        openAlbum(Id) {
            const vm = this;
            let Hash = Id;
            //打API
            API.getAlbumDetail({ Id: Hash }).then(res => {
                if (res.Ok) {
                    vm.Images = res.Data.Photos;
                    vm.DetailTitle = res.Data.Title;
                    vm.YoutubeUrl = res.Data.YoutubeUrl;
                    vm.popupShow = true;
                }
            });
        },
        closeAlbum() {
            const vm = this;
            vm.Images = [];
            vm.YoutubeUrl = null
            vm.swiperTop.removeAllSlides();
            vm.swiperThumbs.removeAllSlides();
            vm.swiperTop.update();
            vm.swiperThumbs.update();
            vm.popupShow = false;
        },
        loadMore() {
            const vm = this;
            vm.busy = true;
            if (vm.Totalpage == vm.Page) {
                return false;
            }
            vm.Page += 1;
            vm.isLoading = true;
            API.getAlbumList({ page: vm.Page, count: vm.Count }).then(
                result => {
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 500);
                    if (result.Data.Albums.length === 0) {
                        return false;
                    } else {
                        setTimeout(function() {
                            vm.busy = false;
                        }, 1000);
                    }
                    let AlbumsList = result.Data.Albums;
                    vm.List = vm.List.concat(AlbumsList);
                }
            );
        }
    },
    computed: {
        swiperThumbs() {
            return this.$refs.swiperThumbs.swiper;
        },
        swiperTop() {
            return this.$refs.swiperTop.swiper;
        }
    },
    created() {
        const vm = this;
        //利用hash獲取詳細
        let Hash = Common.getHash();
        if (Hash) {
            //打API
            // console.log(Hash);
            if (process.env.NODE_ENV === "production") {
                API.getAlbumDetail({ Id: Hash }).then(res => {
                    if (res.Ok) {
                        vm.Images = res.Data.Photos;
                        vm.DetailTitle = res.Data.Title;
                        vm.YoutubeUrl = res.Data.YoutubeUrl;
                        vm.popupShow = true;
                    }
                });
            } else {
                vm.Images = [
                    {
                        Title: "測試",
                        Url: "/static/images/activity/act01.jpg",
                        Sort: 0
                    },
                    {
                        Title: "測試",
                        Url: "/static/images/activity/act02.jpg",
                        Sort: 0
                    },
                    {
                        Title: "測試",
                        Url: "/static/images/activity/act03.jpg",
                        Sort: 0
                    },
                    {
                        Title: "測試",
                        Url: "/static/images/activity/act04.jpg",
                        Sort: 0
                    },
                    {
                        Title: "測試",
                        Url: "/static/images/activity/act05.jpg",
                        Sort: 0
                    }
                ];
                vm.popupShow = true;
            }
        }

        if (vm.propsilhouette) {
            let obj = JSON.parse(vm.propsilhouette);
            vm.List = obj.Albums;
            vm.Totalpage = Math.ceil(parseInt(obj.Total) / vm.Count);
            if (vm.Totalpage == 1 || vm.Totalpage == vm.Page) {
                vm.busy = true;
            }
        } else {
            vm.List = [
                {
                    Id: "cc6481a0-9ef7-4a0b-bd45-8087f44dc8db",
                    Title: "Test相簿S86",
                    Introduction: "Test相簿SR01Test相簿SR01Test相簿SR01",
                    Cover:
                        "https://retinasociety.blob.core.windows.net/album/cc6481a0-9ef7-4a0b-bd45-8087f44dc8db/9a616df55b2447e691c9530fcc875c1a.jpg",
                    Photos: []
                }
            ];
        }
    },
    updated() {
        const vm = this;
        if (vm.Images.length > 0) {
            let length = vm.Images.length;
            if (vm.Init) {
                vm.Init = false;
                vm.swiperTop.init();
                vm.swiperThumbs.init();
                vm.$set(vm.swiperOptionThumbs, "init", true);
                vm.$set(vm.swiperOptionTop, "init", true);
            }
            vm.$nextTick(() => {
                // console.log(this.$refs);
                vm.swiperTop.controller.control = vm.swiperThumbs;
                vm.swiperThumbs.controller.control = vm.swiperTop;
            });
            vm.swiperTop.update();
            vm.swiperThumbs.update();
        }
    },
    mounted() {
        const vm = this;
    },
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#silhouette {
    margin-bottom: 60px;
}
#silhouette .list_box .list {
    width: 100%;
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
    flex-wrap: wrap;
}
#silhouette .list_box .list .item {
    width: 30%;
    max-width: 350px;
    margin-bottom: 10px;
}
#silhouette .list_box .list:after {
    content: "";
    flex: 0 0 30%;
    max-width: 350px;
}
#silhouette .popup {
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background-color: #fff;
    z-index: 999;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
}
.popup .title {
    width: 60%;
    margin: 60px auto 20px;
    font-size: 1.3rem;
    position: relative;
    line-height: 1.5;
}
.popup .title .close {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    font-weight: 600;
    cursor: pointer;
}
.popup .slider {
    width: 100%;
    height: calc(100% - 100px);
}
/* 套件 */
.swiper-container {
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    background-color: #fff;
}
.swiper-slide {
    background-size: cover;
    background-position: center;
}
.gallery-top {
    height: 80% !important;
    width: 60%;
}
.gallery-thumbs {
    height: 20% !important;
    box-sizing: border-box;
    padding: 10px 0;
}
.gallery-thumbs .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
}
.gallery-thumbs .swiper-slide-active {
    opacity: 1;
}
.swiper-button-prev,
.swiper-button-next {
    background-color: #ee8b59;
    background-size: 20px 15px;
    width: 25px;
    height: 50px;
}
.gallery-top .swiper-slide {
    background-size: contain;
    background-repeat: no-repeat;
}
/* 套件END */
@media screen and (max-width: 992px) {
    #silhouette .list_box .list .item {
        width: 48%;
    }
}
@media screen and (max-width: 767px) {
    #silhouette .list .list_box {
        margin-bottom: 60px;
    }

    #silhouette .list_box .list .item {
        width: 100%;
        max-width: 100%;
    }
    .popup .title {
        width: 80%;
    }
    /* 套件 */
    .gallery-top {
        height: 80% !important;
        width: 80%;
    }
}

/* 影片用 */
.video{
position: relative;
padding-bottom: 56.25%;
padding-top: 10px;
height: 0;
overflow: hidden;
}

.video iframe, .video object, .video embed {
position: absolute;
top: 0;
left: 50%;
transform: translateX(-50%);
width: 70%;
height: 70%;
}
</style>



// WEBPACK FOOTER //
// src/pages/silhouette.vue